import React from 'react';
import { Quote } from 'lucide-react';

export default function Testimonials() {
  const reviews = [
    {
      quote: "Professional, thorough, and fast—exactly what our technical department needed prior to the scheduled port call.",
      author: "Operations Lead",
      organization: "Oil Major"
    },
    {
      quote: "Clear recommendations and highly practical risk controls saved our vessel multiple days structural delay at berth.",
      author: "Fleet Manager",
      organization: "Tanker Operator"
    },
    {
      quote: "Reliable documentation and comprehensive root-cause tracking that stood up completely to strict external scrutiny.",
      author: "Claims Adjuster",
      organization: "P&I Club"
    }
  ];

  const clientTypes = ["CDI Vetting", "P&I Clubs", "Oil Majors", "Charterers", "Shipowners", "Underwriters"];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-xs font-bold text-[#87412A] uppercase tracking-widest block mb-2">Track Record</span>
          <h2 className="text-3xl font-bold text-[#1E4363] font-serif">What Clients Say</h2>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20">
          {reviews.map((item, index) => (
            <div key={index} className="bg-[#F9F8F3] p-8 border border-gray-200 rounded-sm relative shadow-sm flex flex-col justify-between">
              <Quote className="absolute top-6 right-6 text-gray-100" size={40} />
              
              <p className="text-[#2C3539]/80 italic text-sm leading-relaxed mb-6 relative z-10">
                "{item.quote}"
              </p>
              
              <div className="border-t border-gray-100 pt-4">
                <p className="font-bold text-[#1E4363] text-sm">{item.author}</p>
                <p className="text-xs text-[#87412A] font-semibold tracking-wider uppercase mt-0.5">{item.organization}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Client Categorization segment */}
        {/* <div className="border-t border-gray-200 pt-16">
          <p className="text-center text-xs font-bold text-[#2C3539]/40 uppercase tracking-widest mb-8">
            Supporting Organizations Across The Value Chain
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-6 text-center">
            {clientTypes.map((type, index) => (
              <div key={index} className="bg-white py-4 px-2 border border-gray-200 rounded-sm text-xs font-bold text-[#1E4363]/70 tracking-wider uppercase shadow-sm">
                {type}
              </div>
            ))}
          </div>
        </div> */}

      </div>
    </section>
  );
}